import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';

interface HotelSettingsCentralMappingSignature {
  Args: {
    controller: unknown;
    model: unknown;
  };
}

<template>
  <div class="central-mapping">
    {{! @glint-expect-error: Incorrect type }}
    {{#if @controller.model.breakdowns.isRunning}}
      <PrismLoadingBar />
    {{/if}}

    {{outlet}}
  </div>
</template> satisfies TOC<HotelSettingsCentralMappingSignature>;
